import { Box } from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';
import { forwardRef, useCallback } from 'react';

import { ButtonProps } from '@/components/form/baseInputs/Button';
import { THEME_SHADOWS } from '@/styles/themes/common';

import { Alert } from '../Alert/Alert';
import { NotificationSeverity } from '../constants';

export interface WrappedAlertProps extends CustomContentProps {
  alertTargetUrl?: string;
  alertActionButton?: {
    label: string;
    buttonProps?: ButtonProps;
  };
}

export function createWrappedAlert(severity: NotificationSeverity) {
  const WrappedAlert = forwardRef<HTMLDivElement, WrappedAlertProps>(
    ({ id, message, alertTargetUrl, alertActionButton }, ref) => {
      const { closeSnackbar } = useSnackbar();
      const handleDismiss = useCallback(() => {
        closeSnackbar(id);
      }, [closeSnackbar, id]);

      return (
        <SnackbarContent ref={ref} role="alert">
          <Box
            data-testid={`FeedbackToast-${severity}`}
            sx={{
              boxShadow: THEME_SHADOWS.md,
              position: 'relative',
              width: 420,
            }}
          >
            <Alert
              severity={severity}
              handleDismiss={handleDismiss}
              alertTargetUrl={alertTargetUrl}
              alertActionButton={alertActionButton}
            >
              {message}
            </Alert>
          </Box>
        </SnackbarContent>
      );
    }
  );
  WrappedAlert.displayName = `WrappedAlert-${severity}`;
  return WrappedAlert;
}
